import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = {
  key: 0,
  class: "z-10 max-w-full text-ellipsis overflow-hidden whitespace-nowrap text-sm text-white px-1 py-0.5 absolute top-0 right-0 bg-green-400"
}
const _hoisted_3 = { class: "" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "mt-1" }
const _hoisted_6 = { class: "xl:text-xl font-medium break-words" }
const _hoisted_7 = ["href"]


export default /*@__PURE__*/_defineComponent({
  __name: 'ImageItem',
  props: {
    image: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.image.listingLabel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.image.listingLabel), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        class: "block w-full",
        src: _ctx.image.image[0].url,
        alt: ""
      }, null, 8, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.image.title), 1),
        _createElementVNode("div", null, [
          _createElementVNode("a", {
            href: _ctx.image.downloadImage[0].url,
            class: "flex items-center gap-x-1",
            download: ""
          }, _cache[0] || (_cache[0] = [
            _createElementVNode("span", null, "Last ned", -1),
            _createElementVNode("span", { class: "material-symbols-outlined text-neutral-500" }, "download", -1)
          ]), 8, _hoisted_7)
        ])
      ])
    ])
  ]))
}
}

})